var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contracts"},[_c('b-table',{attrs:{"striped":"","hover":"","fixed":"","Outlined":"","show-empty":"","empty-text":'No data available',"items":_vm.contracts,"fields":_vm.fields,"table-class":"list-table text-center","thead-class":"list-table__head","tbody-class":"list-table__body"},scopedSlots:_vm._u([{key:"cell(Detail)",fn:function(contract){return [_c('b-button',{staticStyle:{"min-width":"100%"},attrs:{"pill":"","variant":"outline-secondary","size":"sm","to":{
          name: 'TutorContract',
          params: {
            tutorId: _vm.tutor.id,
            contractId: contract.item.contractNumber,
          },
        }}},[_vm._v(" Detail ")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }